import { render, staticRenderFns } from "./PortfolioManager.vue?vue&type=template&id=aa306b12&scoped=true&"
import script from "./PortfolioManager.vue?vue&type=script&lang=ts&"
export * from "./PortfolioManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa306b12",
  null
  
)

export default component.exports